import { generatePassword } from "lib/helpers";
import { CharsetKey } from "lib/models";
import React from "react";

// Define hook response
type UseGeneratedPasswordHookResponse = string;

type UseGeneratedPasswordHookProps = {
  chars?: CharsetKey[];
  length?: number;
};

// Define hook
type UseGeneratedPasswordHook = (
  props?: UseGeneratedPasswordHookProps
) => UseGeneratedPasswordHookResponse;

// Default properties
const defaultProps: Required<UseGeneratedPasswordHookProps> = {
  chars: ["uc", "lc", "n", "s"],
  length: 16,
};

/**
 * Hook to generate a password non-cryptographically.
 */
export const useGeneratedPassword: UseGeneratedPasswordHook = (
  incomingProps
) => {
  const { chars, length } = { ...defaultProps, ...incomingProps };

  // We memoize so that it doesn't change without settings change
  return React.useMemo(() => generatePassword(chars, length), [chars, length]);
};
